(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("english", [], factory);
	else if(typeof exports === 'object')
		exports["english"] = factory();
	else
		root["SurveyLocales"] = factory();
})(this, function() {
return 